export const ACCOUNT_LOGIN = 'ACCOUNT:LOGIN';
export const ACCOUNT_LOGOUT = 'ACCOUNT:LOGOUT';
export const GET_ACCOUNT_DETAILS = 'GET:ACCOUNT:DETAILS';
export const ACCOUNT_REFRESH_CONNEXION = 'ACCOUNT:REFRESH:CONNEXION';
export const RESET_PASSWORD = 'RESET:PASSWORD';
